import { render, staticRenderFns } from "./ResetPasswordEmail.vue?vue&type=template&id=ca361ce6&scoped=true"
import script from "./ResetPasswordEmail.vue?vue&type=script&lang=js"
export * from "./ResetPasswordEmail.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordEmail.vue?vue&type=style&index=0&id=ca361ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca361ce6",
  null
  
)

export default component.exports